import { useInternalRoute } from '~/datocms/useInternalRoute';
import type { GetAlumniSettingsQuery } from '#gql';

export function useAlumniSettings() {
  const { localeProperties } = useI18n();

  const settings = inject('AlumniSettings', {}) as ComputedRef<GetAlumniSettingsQuery['alumniNavigation']>;

  const loginPageRoute = useInternalRoute(settings.value?.loginPage, localeProperties.value.siteLocale);
  const registrationPageRoute = useInternalRoute(settings.value?.registrationPage, localeProperties.value.siteLocale);
  const entryPageAfterLoginRoute = useInternalRoute(
    settings.value?.entryPageAfterLogin,
    localeProperties.value.siteLocale,
  );
  const profilePageRoute = useInternalRoute(settings.value?.profilePage, localeProperties.value.siteLocale);
  const passwordResetPageRoute = useInternalRoute(settings.value?.passwordResetPage, localeProperties.value.siteLocale);

  return {
    loginPageUrl: loginPageRoute.path.value ?? '/',
    registrationPageUrl: registrationPageRoute.path.value ?? '/',
    entryPageAfterLoginUrl: entryPageAfterLoginRoute.path.value ?? '/',
    profilePageUrl: profilePageRoute.path.value ?? '/',
    passwordResetPageUrl: passwordResetPageRoute.path.value ?? '/',
  };
}
